import React from "react";
import qs from "query-string";
import { withI18n } from "react-i18next";
import { withRouter } from "react-router-dom";
import styled, { css } from "styled-components";
import Button from "common/Button";
import CWBLabsFooter from "common/CWBLabsFooter";
import HorizontalDivider from "common/HorizontalDivider";
import LegalSection from "../../../common/LegalSection";
import * as SharedStyle from "../../../common/SharedStyledComponents";
import Typography from "common/Typography";
import ErrorIcon from "images/error.svg";
import { getSupportEmail } from "shared/helpers";

const PwdResetFailed = ({ code, userEmail, t, history, location }) => {
  const qsArgs = qs.parse(location.search);
  const redirectPwdReset = () => {
    const isCWBLabs = qsArgs.cwblabs;
    const params = {
      code: (encodeURIComponent(code) || qsArgs.code || ''),
      email: (encodeURIComponent(userEmail) || qsArgs.email || ''),
      attempt: Number((qsArgs.attempt || 0)) + 1,
      ...(isCWBLabs && { cwblabs: true }),
    };
    if (!params.code || !params.email) {
      history.push(`/login/forgotpwd?${qs.stringify(params, { skipNull: true, skipEmptyString: true, strict: false, encode: false })}`);
    } else {
      history.push(`/login/resetpwd?${qs.stringify(params, { skipNull: true, skipEmptyString: true, strict: false, encode: false })}`);
      history.go();
    }
  };

  const isCWBLabs = qsArgs.cwblabs;

  return isCWBLabs ? (
    <Base isCWBLabs>
      <Card>
        <Icon src={ErrorIcon} />
        <Typography align="center" component="h1" variant="h3">
          {t("Password Already Reset")}
        </Typography>
        <HorizontalDivider destructive />
        <Typography align="center">
          {t(
            "Your password failed to reset. Please try again by clicking on the link below or contact our"
          )}
          &nbsp;
          <a href={`mailto:${getSupportEmail}`}>{t("support team")}</a>.
        </Typography>
        <StyledButton destructive onClick={redirectPwdReset}>
          {t("Try Again")}
        </StyledButton>
      </Card>
      <CWBLabsFooter />
    </Base>
  ) : (
    <Base>
      <Wrapper>
        <SharedStyle.FormWrapper>
          <SharedStyle.FormHeaderError>
            {t("PASSWORD RESET FAILED")}
          </SharedStyle.FormHeaderError>
          <SharedStyle.FormBody>
            <p>
              {t(
                "Your password failed to reset. Please try again by clicking on the link below or contact our"
              )}
              &nbsp;
              <a href={`mailto:${getSupportEmail}`}>{t("support team")}</a>.
            </p>
            <SharedStyle.SubmitDangerButton
              className="cwb-btn-primary"
              onClick={redirectPwdReset}
            >
              {t("Try Again")}
            </SharedStyle.SubmitDangerButton>
          </SharedStyle.FormBody>
          <LegalSection />
        </SharedStyle.FormWrapper>
      </Wrapper>
    </Base>
  );
};

const Base = styled.div`
  width: 100%;
  height: calc(100vh - 60px);
  padding: 10vh 0;

  @media (max-width: 375px) {
    padding: 5vh 0;
  }

  ${(p) => p.isCWBLabs && css`
    height: calc(100vh - 80px);
    background-color: #040F1C;
  `}
`;

const Wrapper = styled.div`
  width: 610px;
  margin: auto;
  background: white;

  @media (max-width: 475px) {
    width: 100%;
  }
`;

const Card = styled.div`
  width: 400px;
  display: flex;
  flex-flow: column nowrap;
  margin: auto;
  padding: 16px 18px 24px;
  background-color: #FFFFFF;
  border-top: 6px solid #E5084A;
  border-radius: 4px;

  @media (max-width: 375px) {
    width: unset;
    margin: 0 16px;
  }
`;

const Icon = styled.img`
  width: 30px;
  height: auto;
  align-self: center;
  margin-bottom: 8px;
`;

const StyledButton = styled(Button)`
  margin-top: 16px;
`;

export default withI18n()(withRouter(PwdResetFailed));
